import auth from '../../services/auth'
import MessageDialog from '../../components/message-dialog.vue'
import { toNumber } from 'lodash'

export default {

  props: ['origin'],

  data() {
    return {
      taxIdNumber: undefined,
      formState: 'NEW',
      loading: false,
      TFACode: undefined,
      errorMessage: undefined,
      enabledButton: false,
      TFACodeInput: null,
      tokenInput: '',
    }
  },

  computed: {
    type() {
      return this.origin || this.$route.params.type;
    }
  },

  created() {
    this.taxIdNumber = auth.getTaxIdNumber();
  },

  methods: {
    requestAgain() {
      const hash = auth.getHash();
      const isAccountUnlock = hash.includes('escolher-canal/desbloqueioConta');
      const isResetPassword = hash.includes('escolher-canal/reset');

      const redirectPage = isResetPassword || isAccountUnlock ? 'password-set' : 'login';
      const redirectParams = isResetPassword || isAccountUnlock ? 'desbloqueioConta' : 'reset';

      const origin = isResetPassword ? 'RESET_PASSWORD' : "LOGIN";

      this.formState = 'NEW';
      this.$validator.validateAll().then(success => {
        auth.tokenGenerateResend(this.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), origin);
        console.log('codigo reenviado');
      });
    },

    doRequest() {
      this.taxIdNumber = auth.getTaxIdNumber();
      const originTelas = this.origin || this.$route.params.type;
      console.log('taxId ', this.taxIdNumber, originTelas);
      if (originTelas == 'UPDATE_USER_EMAIL') {
        this.$validator.validateAll().then(success => {
          this.loading = auth.twoFactorAuthentication(this.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), this.tokenInput, originTelas)
            .then(data => {
              console.log(auth.currentUser.moveMaisId);
              auth.changeCurrentUser(auth.currentUser.moveMaisId);
              this.$router.push({ name: 'user-contacts-change', params: { type: originTelas } });
            })
            .catch(err => {
              console.error(err);
              this.errorMessage = err.data.status.message;
            })
        });
      };

      if (originTelas == 'UPDATE_NEW_USER_EMAIL') {
        this.$validator.validateAll().then(success => {
          this.loading = auth.twoFactorAuthentication(this.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), this.tokenInput, originTelas)
            .then(data => {
              return auth.updateNewUserEmail(this.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), auth.getNewEmail())
                .then(() => {
                  MessageDialog.show({
                    headerClass: 'modal-success',
                    title: 'Alteração cadastral',
                    message: 'Novo e-mail cadastrado com sucesso!',
                    type: 'OK'
                  });
                  auth.changeCurrentUser(auth.currentUser.moveMaisId);
                  auth.changeCurrentUser(auth.currentUser.moveMaisId);
                  this.$router.push({ name: 'plans' });
                })
            }).catch(err => {
              console.error(err);
              this.errorMessage = err.data.status.message;
            })

        });
      };

      if (originTelas == 'UPDATE_PASSWORD') {
        this.$validator.validateAll().then(success => {
          this.loading = auth.twoFactorAuthentication(this.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), this.tokenInput, originTelas)
            .then(data => {
              this.$router.push({ name: 'password-change' });
            }).catch(err => {
              console.error(err);
              this.errorMessage = err.data.status.message;
            })
        });
      };

      if (originTelas == 'UPDATE_USER_PHONE') {
        this.$validator.validateAll().then(success => {
          this.loading = auth.twoFactorAuthentication(this.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), this.tokenInput, originTelas)
            .then(data => {
              auth.changeCurrentUser(auth.currentUser.moveMaisId);
              this.$router.push({ name: 'user-contacts-change', params: { type: originTelas } });
            })
            .catch(err => {
              console.error(err);
              this.errorMessage = err.data.status.message;
            })
        });
      };

      if (originTelas == 'UPDATE_NEW_USER_PHONE') {
        this.$validator.validateAll().then(success => {
          this.loading = auth.twoFactorAuthentication(this.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), this.tokenInput, originTelas)
            .then(data => {
              auth.updateNewUserPhone(this.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), auth.getNewPhone())
                .then(() => {
                  MessageDialog.show({
                    headerClass: 'modal-success',
                    title: 'Alteração cadastral',
                    message: 'Novo celular cadastrado com sucesso!',
                    type: 'OK'
                  });
                  auth.changeCurrentUser(auth.currentUser.moveMaisId);
                  this.$router.push({ name: 'plans' });
                })
            }).catch(err => {
              console.error(err);
              this.errorMessage = err.data.status.message;
            })

        });
      };

      if (originTelas == 'SMS' || originTelas == 'EMAIL') {
        this.$validator.validateAll().then(success => {
          this.loading = auth.twoFactorAuthentication(this.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), this.tokenInput, 'LOGIN')
          .then(data => {
            auth.changeCurrentUser(auth.getMoveMaisId()).then(r => {
              this.$router.push({name: 'plans', query: { showPromotionalModal: true }});
            });
          })
          .catch(err => {
            console.error(err);
            this.errorMessage = err.data.status.message;
          });
        });
        
      }

      if (originTelas == 'UPDATE_ACCOUNT') {
        this.$validator.validateAll().then(success => {
          this.loading = auth.twoFactorAuthentication(this.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), this.tokenInput, originTelas)
            .then(data => {
              this.$emit("sucess2fa");
            }).catch(err => {
              console.error(err);
              this.errorMessage = err.data.status.message;
            });

       });
      }

      if (originTelas == 'RESET_PASSWORD') {
        this.$validator.validateAll().then(success => {
          this.loading = auth.twoFactorAuthentication(this.taxIdNumber.replace(/[.\-\/]/g, '').toUpperCase(), this.tokenInput, originTelas)
            .then(data => {
              this.$router.push({name: 'password-set', params: { type: 'reset' }});
            }).catch(err => {
              console.error(err);
              this.errorMessage = err.data.status.message;
            });

       });
      }

    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/auth/2fa-interno.js